import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKudos = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Grey",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_173",
		"data-name": "Group 173",
		transform: "translate(-836.218 -221.113)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_337",
				"data-name": "Path 337",
				d: "M852.622,233.032a12.149,12.149,0,0,1-.581,1.716,12.722,12.722,0,0,1-1.569,2.7c-.416.553-.833,1.109-1.2,1.7a5.25,5.25,0,0,0-.806,2.677q0,.178,0,.359a6.3,6.3,0,0,0,.122,1h-.052a7.908,7.908,0,0,1-6.372-3.664,6.408,6.408,0,0,1-.848-2.488,11.989,11.989,0,0,1,.361-4.821,15.109,15.109,0,0,1,1.464-3.6c.03-.053.064-.1.1-.167-.056.262-.118.507-.157.755a3.951,3.951,0,0,0,.09,1.758,2.091,2.091,0,0,0,1.657,1.549,3.636,3.636,0,0,0,2.08-.143,2.991,2.991,0,0,0,1.743-1.781,5.805,5.805,0,0,0,.362-2.545,8.445,8.445,0,0,0-.785-3.139,5.281,5.281,0,0,0-1.218-1.724.155.155,0,0,1-.02-.027l.021-.034c.4.223.817.434,1.211.673a10.853,10.853,0,0,1,3.13,2.784,7.392,7.392,0,0,1,1.445,3.463A7.763,7.763,0,0,1,852.622,233.032Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_338",
				"data-name": "Path 338",
				d: "M868.376,251.761a5.585,5.585,0,0,1-.482.889h0a10.151,10.151,0,0,1-.959,1.1,8.42,8.42,0,0,1-2.068,1.519h0a7,7,0,0,1-2.1.694c-.015-.068-.029-.135-.042-.2a3.526,3.526,0,0,1-.025-1.094,4.912,4.912,0,0,1,.34-1.233,8.743,8.743,0,0,1,1.475-2.37,9.611,9.611,0,0,0,1.619-2.781c.137-.349.26-.706.373-1.068a10.136,10.136,0,0,0,.428-1.993,3.532,3.532,0,0,0-.035-1.165c.048.069.1.136.144.206a10.978,10.978,0,0,1,1.643,3.889A6.008,6.008,0,0,1,868.376,251.761Z",
				transform: "translate(-13.175 -12.865)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_339",
				"data-name": "Path 339",
				d: "M874.686,266.329a5.717,5.717,0,0,1-.959,1.1A10.171,10.171,0,0,0,874.686,266.329Z",
				transform: "translate(-19.967 -26.543)",
				fill: "#b3b2b3"
			})
		]
	}), /* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_687",
		"data-name": "Rectangle 687",
		width: 24,
		height: 24,
		fill: "rgba(255,255,255,0)"
	})]
});
export default SvgKudos;
